import {PlayerEnums} from '../../../../../shared/GameEnums'
import {SocketDataTypes} from '../../../../../shared/SocketDataTypes'
import {ClientUserState} from '../../../../shared/scripts/ClientUserState'
import {clientI18n} from '../../../../shared/scripts/ClientI18n'
import {Sound} from '../../../../shared/scripts/Sound'
import {UIUtilsEjsVariables} from '../../../../shared/scripts/UIUtilsEjsVariables'
import {createImgIn, createSpanIn, setElementInnerHTML} from '../../../../shared/scripts/ui_utils/DomUtils'
import {UIManager} from '../UIManager'
import {UIWLandingPageController} from './UIWLandingPageController'
import {UIDiscordInstance} from '../../discord/child_iframe/UIDiscordInstance'
import {SocketLobbySend} from '../../../../shared/scripts/socket/SocketLobbySend'
import {RoomType} from '@colonist/lobby-types'
import {LobbyImage} from '@colonist/types'
import {AjaxDataTypes} from '../../../../../shared/AjaxDataTypes'
import {AnalyticEventCategory, AnalyticEventType} from '../../../../../shared/entity_datas/EntityDatas'
import {CA} from '../../../../shared/scripts/analytics/Analytics'
import {UIHomepageCTAController} from '../home_page/UIHomepageCTAController'
import {SDKRequest} from '../../../../../shared/DiscordActivityTypes'

export class UIDLandingPageController extends UIWLandingPageController {
    private readonly multiplayerCTA: HTMLLinkElement
    private readonly joinColonistDiscordCTA: HTMLLinkElement

    private triggerInviteFriendsPopup: boolean = false

    constructor(uiManager: UIManager) {
        super(uiManager)

        this.multiplayerCTA = document.getElementById('landingpage_cta_create') as HTMLLinkElement

        this.joinColonistDiscordCTA = document.getElementById('landingpage_cta_joindiscord') as HTMLLinkElement
        this.initializeJoinDiscordCTA()

        this.setButtonActions()
    }

    protected clickSinglePlayerCTA() {
        this.uiManager.matchmakingController.selectMatchPopupView.showSinglePlayerOptions()
        this.uiManager.matchmakingController.selectMatchPopupView.show()
    }

    updateDiscordCTAContent(roomData: SocketDataTypes.ChannelRoomUpdate) {
        if(!UIUtilsEjsVariables.isUserOnDiscord) throw new Error('This should only be called on the discord integration server')

        setElementInnerHTML(this.multiplayerCTA, {key: 'strings:colonistCommon.utils.emptyString'})

        this.multiplayerCTA.innerText = clientI18n.t('strings:homePage.ctas.play.title', {context: 'web'})
        this.multiplayerCTA.onclick = () => this.defaultMainCTAAction()
        this.landingPageCTAMain.onclick = () => this.defaultMultiplayerCTAAction()

        this.triggerInviteFriendsPopup = false

        if(roomData.type == PlayerEnums.ChannelStatus.Closed) {
            this.landingPageCTAMain.innerText = clientI18n.t('strings:homePage.ctas.play.title', {context: 'discord'})
            this.triggerInviteFriendsPopup = true
            return
        }

        if(roomData.type == PlayerEnums.ChannelStatus.Game) {
            this.landingPageCTAMain.innerText = clientI18n.t('strings:homePage.ctas.spectate')
            return
        }

        if(roomData.type == PlayerEnums.ChannelStatus.Reconnect) {
            this.landingPageCTAMain.innerText = clientI18n.t('strings:homePage.ctas.rejoinGame')
            return
        }

        const playersInRoom = roomData.playersInRoom
        const maxPlayers = roomData.maxPlayers
        const isGameFull = playersInRoom >= maxPlayers

        if(isGameFull) {
            this.landingPageCTAMain.innerText = clientI18n.t('strings:homePage.ctas.roomFull')
            return
        }

        this.landingPageCTAMain.innerText = clientI18n.t('strings:homePage.ctas.joinRoom')
    }

    private defaultMultiplayerCTAAction() {
        Sound.playSound(Sound.SoundType.Click)

        const channelId = UIDiscordInstance.getDiscordInstance().voiceChannelId
        SocketLobbySend.clickedJoinChannelRoomOrGame(channelId, RoomType.DiscordActivity)

        if(UIHomepageCTAController.shouldTriggerInviteFriendsPopup(this.triggerInviteFriendsPopup, UIDiscordInstance.getDiscordInstance())) UIDiscordInstance.getDiscordInstance().sendSDKRequest(SDKRequest.InviteFriends)
    }

    private defaultMainCTAAction() {
        Sound.playSound(Sound.SoundType.Click)

        this.clickLandingPageCTAMain()
    }

    private setButtonActions() {
        this.multiplayerCTA.onclick = () => this.defaultMultiplayerCTAAction()

        this.joinColonistDiscordCTA.onclick = () => {
            const eventData: AjaxDataTypes.AnalyticData = {
                type: AnalyticEventType.ClickedJoinColonistDiscordCTA,
                category: AnalyticEventCategory.DiscordServer,
            }
            void CA.sendAnalyticEvent(eventData)
        }

        this.landingPageCTAMain.onclick = () => this.defaultMainCTAAction()
    }

    private initializeJoinDiscordCTA() {
        createImgIn(this.joinColonistDiscordCTA, LobbyImage.DiscordIcon)
        createSpanIn(this.joinColonistDiscordCTA, '', {key: 'strings:homePage.ctas.joinDiscord'})

        this.joinColonistDiscordCTA.hidden = ClientUserState.userState?.hasJoinedColonistDiscordServer == true
    }
}
